import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IApiError } from '../../../react-core/Core/ApiError';
import { AdviserConfigurationInstruction } from '../../Models/Models/Adviser/Configuration/AdviserConfigurationInstruction';
import { AdviserConfigurationInstructionErrors } from '../../Validation/Errors/Adviser/AdviserConfigurationInstructionErrors';
import { CreateAdviserConfigurationInstructionQuery } from '../../Models/Models/Adviser/Configuration/CreateAdviserConfigurationInstructionQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class AdviserConfigurationInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: number): Promise<AdviserConfigurationInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Adviser/AdviserConfigurationInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<AdviserConfigurationInstruction, any>(url, data);
  }
  public post(query: CreateAdviserConfigurationInstructionQuery): Promise<AdviserConfigurationInstruction, IApiError<AdviserConfigurationInstructionErrors>[]> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Adviser/AdviserConfigurationInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.post<AdviserConfigurationInstruction, IApiError<AdviserConfigurationInstructionErrors>[]>(url, data);
  }
}

